// @flow

import { getMustRedirectAfterPayment } from '@tectonics/prs/incoming-payment/get-must-redirect-after-payment';
import { getMustRedirectAfterPaymentConfirmed } from '@tectonics/prs/incoming-payment/get-must-redirect-after-payment-confirmed';
import type { IncomingPayment } from '@tectonics/prs/incoming-payment/types';

export function shouldRedirect(incomingPayment: IncomingPayment): boolean {
  return shouldSkipPendingPage(incomingPayment) || shouldSkipConfirmedPage(incomingPayment);
}

function shouldSkipPendingPage(incomingPayment: IncomingPayment): boolean {
  return incomingPayment.status === 'PE' && getMustRedirectAfterPayment(incomingPayment);
}

function shouldSkipConfirmedPage(incomingPayment: IncomingPayment): boolean {
  return incomingPayment.status === 'CO' && (getMustRedirectAfterPayment(incomingPayment) || getMustRedirectAfterPaymentConfirmed(incomingPayment));
}
